<template>
<span>
  <!-- clickable as routerlink -->
  <router-link v-if="to" :to="to" v-bind:style="{backgroundColor, color, transform}" class="ui-icon">
    <font-awesome-icon v-if="!loading" class="icon" v-bind="{ icon }" />
    <spinner class="spinner" v-if="loading"/>
  </router-link>

  <!-- not clickable as reouterlink  -->
  <div v-if="!to" v-bind:style="{backgroundColor, color , transform}" class="ui-icon">
    <font-awesome-icon v-if="!loading" class="icon" v-bind="{ icon }" />
    <spinner color="#FFFFFF" class="spinner" v-if="loading"/>
  </div>
</span>

</template>

<script>
import Spinner from '../components/Spinner.vue';

export default {
  name: 'ui-icon',
  props:{
    backgroundColor:{ default:'#FF0000' },
    color:{default:'#FFFFFF'},
    icon:{default:'plus'},
    to:{default:""},
    loading:{default:false},
    transform:{default:"rotateZ(0deg)"},
  },
  computed:{
    getIconName(){
      return '';
    },
  },
  components:{
    Spinner,
  },
  data:function(){
    return {
    }
  },
  methods:{
    
  },
  mounted(){

    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ui-icon{
  border-radius:9999999px;
  width:1.81em;
  height:1.81em;
  display:inline-flex;
  align-items: center;
  justify-content: center;
  font-size:.9em;
}

.spinner{
  font-size:inherit;
}
</style>
